import { TweenMax } from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';

export default {
    to(el, duration = 1, offsetY = 0) {
        TweenMax.to(
            window,
            duration,
            {
                scrollTo: {
                    y: el,
                    offsetY
                },
                autoKill:false
            }
        );
    }
}